import React from "react";
import { Menu, Grid, Modal, Header, Segment } from 'semantic-ui-react';
import { compose, graphql } from 'react-apollo';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { Task } from '../queries/Task'
import mapConnection from '../utils/connectionMapper'
import SandboxedHTMLContent from './SandboxedHTMLContent'
import AttachmentsList from './AttachmentsList'

class ClaimEmailMessagesSidebar extends React.Component {
  state={}

  handleItemClick = (id) => {
    this.setState({
      isModalOpen: true,
      activeId: id
    })
  }

  handleModalClose = () => this.setState({isModalOpen: false, activeId: ''})

  render = () => (
    <Segment loading = {this.props.Task.loading}>
      {this.renderModal()}
      <div style={{display: 'flex', flexDirection: 'column', maxHeight: '100%'}}>
        <Menu.Item style={{padding: 0}}/>
        <div>
          {this.props.Task.task
            && mapConnection(this.props.Task.task.claim.emailMessagesConnection).length === 0
            ? <Menu.Item>No messages to display</Menu.Item>
            : null}
          {this.props.Task.task
            && mapConnection(this.props.Task.task.claim.emailMessagesConnection).map((el, index) =>
            this.renderItem(el, index, {key: index})
          )}
        </div>
      </div>
    </Segment>
  )

  renderItem = (el, index, additionalProps) =>
    <Menu.Item
      onClick={this.handleItemClick.bind(this, el.id)}
      {...additionalProps}
    >
      <Grid>
        <Grid.Row>
          <Grid.Column>
            { el.claimState }
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign={'right'}>
            {moment(el.createdAt).format('DD/MM/YYYY')}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column style={{wordWrap: "break-word"}}>
            {el.type === 'outgoing' ? `Sent to ${el.to}` : null}
            {el.type === 'incoming' ? `Received from ${el.from}` : null}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Menu.Item>

    renderModal = () => {
      const currentMessage = this.props.Task.task
        && mapConnection(this.props.Task.task.claim.emailMessagesConnection)
        .find(message => message.id === this.state.activeId)
      const documents = currentMessage ? mapConnection(currentMessage.documentsConnection) : []
      return (
        <Modal
          open={this.state.isModalOpen}
          onClose={this.handleModalClose}
          closeIcon
        >
          <Modal.Header>
            <Grid>
              <Grid.Row columns={'two'}>
                <Grid.Column>
                  {currentMessage && currentMessage.claimState} <br/>
                  {currentMessage && currentMessage.type === 'outgoing' ? `Sent to ${currentMessage.to}` : null}
                  {currentMessage && currentMessage.type === 'incoming' ? `Received from ${currentMessage.from}` : null}
                </Grid.Column>
                <Grid.Column textAlign={'right'}>
                  {currentMessage && moment(currentMessage.createdAt).format('DD/MM/YYYY')}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Header>{currentMessage && currentMessage.subject}</Header>
              <p>{currentMessage && currentMessage.htmlPart ?
                <SandboxedHTMLContent
                  contentStyle={{
                    width: `100%`,
                    height: `500px`,
                    border: `none`
                  }}
                  documents={documents}
                  htmlPart={currentMessage.htmlPart}
                />
                :
                currentMessage && currentMessage.content
              }
              </p>
              {
                currentMessage && 
                <AttachmentsList 
                  attachments={documents}
                />                
              }                
            </Modal.Description>
          </Modal.Content>
        </Modal>
      )
    }
}

const ClaimEmailMessagesSidebarWithData = compose(
  withRouter,
  graphql(Task, {
    name: 'Task',
    options: (props) => {
      return {
        variables: {
          id: props.match.params.id
        }
      }
    },
    notifyOnNetworkStatusChange: true
  })
)(ClaimEmailMessagesSidebar);

export default ClaimEmailMessagesSidebarWithData;



// WEBPACK FOOTER //
// ./src/component/ClaimEmailMessagesSidebar.js